export const timeMessages = {
  "time.relative.justNow": "just now",
  "time.relative.daysAgoShort": "{count}d ago",
  "time.relative.hoursAgoShort": "{count}h ago",
  "time.relative.minutesAgoShort": "{count}m ago",
} as const
